module.exports = __webpack_public_path__ + "img/step_5.9eef9255.png";